import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HostSEACE, HttpHeaderToken } from '../general/variables';
import { ObjetoSeace } from '../models/ObjetoSeace';
import { TipoSeleccionSeace } from '../models/TipoSeleccionSeace';
import { ContratacionSEACE } from '../models/ContratacionSEACE';
import { AnhoConvSeace } from '../models/AnhoConvSeace';
import { ModalidadSelecSeace } from '../models/ModalidadSelecSeace';
import { TipoCompraSeace } from '../models/TipoCompraSeace';

@Injectable({
  providedIn: 'root'
})
export class SeaceService {

  constructor(protected http: HttpClient) { }

  // tslint:disable-next-line: ban-types
  url: String = `${HostSEACE}`;



  listarAnhoConvocatoria() {
    return this.http.get<AnhoConvSeace[]>(`${this.url}/SEACE/getConvocatoria`, HttpHeaderToken());
  }

  listarModalidadSelecc() {
    return this.http.get<ModalidadSelecSeace[]>(`${this.url}/SEACE/getModalidad`, HttpHeaderToken());
  }


  buscarContratacionSeace(contratacionSEACE: ContratacionSEACE) {
    // return this.http.post<ContratacionSEACE[]>(`${this.url}/SEACE/getListadoGe/`,contratacionSEACE);
    return this.http.post<ContratacionSEACE[]>(`${this.url}/consulta/listarCabecera/`, contratacionSEACE, HttpHeaderToken());
  }

}
